import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Icon, Row, Col } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;

let id = 0;

class TrafficSignsMessageForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {      
      if (!err) {
        var data = {};
        for (let key of values.keys) {
          data[values.names[key]] = values.values[key];
        }
        this.props.onSuccess(this.props.form, { data: data, settings: values.settings });
      }
    });
  }

  addMessageItem = () => {
    const { form } = this.props;

    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);

    form.setFieldsValue({
      keys: nextKeys,
    });
  }

  removeMessageItem = (k) => {
    const { form } = this.props;

    const keys = form.getFieldValue('keys');
    if (keys.length === 1) {
      return;
    }

    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  }

  renderForm() {
    const { getFieldDecorator, getFieldValue } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 20, offset: 6 },
      },
    };

    getFieldDecorator('keys', { initialValue: [] });
    const keys = getFieldValue('keys');
    const formMessageItems = keys.map((k, index) => (
      <Row key={k}>
        <Col>
          <Form.Item
            {...formItemLayout}
            label="Název"
            required={false} >
            {getFieldDecorator(`names[${k}]`, {
              validateTrigger: ['onChange', 'onBlur'],
              rules: [{
                required: true,
                whitespace: true,
                message: "Prosím vyplňte název proměnné",
              }],
            })(
              <Input placeholder="Název" />
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Hodnota"
            required={false} >
            {getFieldDecorator(`values[${k}]`, {
              validateTrigger: ['onChange', 'onBlur'],
              rules: [{
                required: true,
                whitespace: true,
                message: "Prosím vyplňte hodnotu proměnné",
              }],
            })(
              <Input placeholder="Hodnota" style={{ width: '80%', marginRigth: 10 }} />
            )}
            {keys.length > 1 ? (
              <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                disabled={keys.length === 1}
                onClick={() => this.removeMessageItem(k)}
              />
            ) : null}
          </Form.Item>
        </Col>
      </Row>
    ));

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Schéma" >
          {getFieldDecorator('settings.textPattern', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.textPattern
              ? this.props.initialValues.defaultSettings.textPattern
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input.TextArea
              autosize={{
                maxRows: 7
              }} />
          )}
        </FormItem>
        {formMessageItems}
        <Form.Item {...formItemLayoutWithOutLabel}>
          <Button type="dashed" onClick={this.addMessageItem} style={{ width: '60%' }}>
            <Icon type="plus" /> Přidat parametr
          </Button>
        </Form.Item>
        <Divider />
        <FormItem
          {...formItemLayout}
          label="Barva pozadí" >
          {getFieldDecorator('settings.backgroundColor', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.backgroundColor
              ? this.props.initialValues.defaultSettings.backgroundColor
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="K"><span style={{ height: 10, width: 10, backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Black</Select.Option>
              <Select.Option value="W"><span style={{ height: 10, width: 10, backgroundColor: 'white', borderRadius: '50%', display: 'inline-block', border: '1px solid #bbb' }}></span>{' '}White</Select.Option>
              <Select.Option value="R"><span style={{ height: 10, width: 10, backgroundColor: 'red', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Red</Select.Option>
              <Select.Option value="G"><span style={{ height: 10, width: 10, backgroundColor: 'green', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Green</Select.Option>
              <Select.Option value="B"><span style={{ height: 10, width: 10, backgroundColor: 'blue', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Blue</Select.Option>
              <Select.Option value="C"><span style={{ height: 10, width: 10, backgroundColor: 'cyan', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Cyan</Select.Option>
              <Select.Option value="M"><span style={{ height: 10, width: 10, backgroundColor: 'magenta', borderRadius: '50%', display: 'inline-block' }}></span>{' '} Magenta</Select.Option>
              <Select.Option value="Y"><span style={{ height: 10, width: 10, backgroundColor: 'yellow', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Yellow</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Barva textu" >
          {getFieldDecorator('settings.color', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.color
              ? this.props.initialValues.defaultSettings.color
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="K"><span style={{ height: 10, width: 10, backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Black</Select.Option>
              <Select.Option value="W"><span style={{ height: 10, width: 10, backgroundColor: 'white', borderRadius: '50%', display: 'inline-block', border: '1px solid #bbb' }}></span>{' '}White</Select.Option>
              <Select.Option value="R"><span style={{ height: 10, width: 10, backgroundColor: 'red', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Red</Select.Option>
              <Select.Option value="G"><span style={{ height: 10, width: 10, backgroundColor: 'green', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Green</Select.Option>
              <Select.Option value="B"><span style={{ height: 10, width: 10, backgroundColor: 'blue', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Blue</Select.Option>
              <Select.Option value="C"><span style={{ height: 10, width: 10, backgroundColor: 'cyan', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Cyan</Select.Option>
              <Select.Option value="M"><span style={{ height: 10, width: 10, backgroundColor: 'magenta', borderRadius: '50%', display: 'inline-block' }}></span>{' '} Magenta</Select.Option>
              <Select.Option value="Y"><span style={{ height: 10, width: 10, backgroundColor: 'yellow', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Yellow</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zarovnání" >
          {getFieldDecorator('settings.aligment', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings && this.props.initialValues.defaultSettings.aligment
              ? this.props.initialValues.defaultSettings.aligment
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="L">Zleva</Select.Option>
              <Select.Option value="C">Na střed</Select.Option>
              <Select.Option value="R">Zprava</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Platnost zprávy" >
          {getFieldDecorator('settings.duration', {
            initialValue: this.props.initialValues && this.props.initialValues.defaultSettings
              ? this.props.initialValues.defaultSettings.duration
              : null,
            rules: [{
              type: 'integer', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <InputNumber
              min={0}
              max={1440} />
          )}
        </FormItem>
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Odeslat</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title="Nová zpráva pro informační tabuli"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText="Odeslat"
          onOk={this.handleSubmit}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TrafficSignsMessageForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsMessageForm.js